import React, { useEffect, useRef } from 'react'
import gsap from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

const Summary = () => {
  const sectionRef = useRef(null)

  useEffect(() => {
    const block = sectionRef.current
    gsap.set(block, { opacity: 0, y: 40 })

    ScrollTrigger.create({
      trigger: block,
      start: 'top 85%',
      once: true,
      onEnter: () => {
        gsap.to(block, {
          opacity: 1,
          y: 0,
          duration: 0.6,
          ease: 'power3.out'
        })
      }
    })

    return () => ScrollTrigger.getAll().forEach(t => t.kill())
  }, [])

  return (
    <section className="summary-section" ref={sectionRef}>
      <div className="alignment-wrapper">
        <h2>Summary</h2>
        <p className="summary-text">
          The Real World Asset Platform combines crowdfunding with blockchain-based royalty tracking, offering a unique
          system for Founders to raise funds and Backers to earn royalties and rewards. By integrating social media promotion
          via the LinkFi App, tiered status levels, and interoperable wallets, the platform creates an engaging ecosystem for
          both creators and supporters.
        </p>
      </div>
    </section>
  )
}

export default Summary
